import translations from './translations'

translations.add('is', {
    yourKlarnaPaymentUnsuccessful: 'Klarna greiðslan þín tókst ekki. Vinsamlegast reyndu aftur síðar'
})
